import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { store } from "@/redux/store";
import { pageViewsApi } from "@/services/page-views.service";
import { isCurrentLocalDevHost } from "@/utils/is-local-dev-host";
import { postLog } from "@/lib/logs";
import { capturarOrigemDaUrl, formatarOrigem } from "@/lib/origem-aquisicao";

interface PageViewLoggerProps {
  children: React.ReactNode;
}

export function PageViewLogger({ children }: PageViewLoggerProps) {
  const location = useLocation();
  const [isStoreReady, setIsStoreReady] = useState(false);
  const lastPathRef = useRef<string>("");

  useEffect(() => {
    const checkStore = () => {
      try {
        const state = store.getState();
        if (state) {
          setIsStoreReady(true);
        }
      } catch (error) {
        console.error("Store ainda não está pronto:", error);
      }
    };

    checkStore();

    if (!isStoreReady) {
      const timer = setTimeout(checkStore, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (!isStoreReady) return;
    if (isCurrentLocalDevHost()) return;

    if (location.pathname === lastPathRef.current) return;

    const logPageView = async () => {
      try {
        const state = store.getState() as { generalReducer?: { LoginId?: number } };
        const loginId = state.generalReducer?.LoginId;
        const origem = formatarOrigem(capturarOrigemDaUrl(location.search, location.pathname));

        await store
          .dispatch(
            pageViewsApi.endpoints.recordPageView.initiate({
              path: location.pathname,
              origin: window.location.origin,
              ...(loginId != null && loginId > 0 && { LoginId: loginId }),
              ...(origem && { origem }),
            })
          )
          .unwrap();

        void postLog({
          Tipo: "Client_ScreenView",
          Objeto: {
            acao: "screen_view",
            screen: location.pathname,
          },
        });

        lastPathRef.current = location.pathname;
      } catch (error) {
        console.error("Erro ao registrar visualização de página:", error);
      }
    };

    logPageView();
  }, [location.pathname, isStoreReady]);

  return <>{children}</>;
} 